package com.eladfinish.bible.contest.data.common

enum class DocumentTextType(
    val extension: String,
    val mimeType: String,
) {
    TXT(extension = "txt", mimeType = "text/plain"),
    HTML(extension = "html", mimeType = "text/html"),
    PDF(extension = "pdf", mimeType = "application/pdf"),
}

interface DocumentsExporter {

    fun savePdfToDocuments(folder: String, name: String, data: ByteArray): String?

    fun saveTextFileToDocuments(
        folder: String,
        name: String,
        content: String,
        type: DocumentTextType = DocumentTextType.TXT,
    ): Boolean

    fun listTextFilesInDocuments(
        folder: String,
        type: DocumentTextType = DocumentTextType.TXT,
    ): List<String>

    fun readTextFileFromDocuments(
        folder: String,
        name: String,
        type: DocumentTextType = DocumentTextType.TXT,
    ): String?

    fun deleteTextFileFromDocuments(
        folder: String,
        name: String,
        type: DocumentTextType = DocumentTextType.TXT,
    ): Boolean

    fun renameTextFileInDocuments(
        folder: String,
        oldName: String,
        newName: String,
        type: DocumentTextType = DocumentTextType.TXT,
    ): Boolean
}
